import { Input } from 'src/components/Input';
import { SkillCard } from './SkillCard';
import { useState } from 'react';

type IvrNavigationConfig = {
  goal: string;
  max_steps?: number;
};

export const validateIvrNavigationConfig = (
  config: IvrNavigationConfig | undefined,
): boolean => {
  if (!config || !config.goal || !config.max_steps) {
    return false;
  }
  return !!config.goal.trim() && !Number.isNaN(config.max_steps);
};

export function IvrNavigationSkill({
  config,
  onConfigChange,
}: {
  config: IvrNavigationConfig;
  onConfigChange?: (config: IvrNavigationConfig) => void;
}) {
  return (
    <SkillCard description="Define the goal and limit how many menu levels the IVR will navigate.">
      <div className="mb-4">
        <Input
          label="Goal"
          placeholder="Enter goal"
          value={config.goal}
          onChange={(e) =>
            onConfigChange?.({ ...config, goal: e.target.value })
          }
          required
        />
      </div>
      <div className="mb-4">
        <Input
          label="Maximum menu selections"
          placeholder="Number of menu options to go through before stopping"
          value={config.max_steps ?? ''}
          onChange={(e) => {
            const val = e.target.value;
            // Only allow numbers
            if (!val || /^\d+$/.test(val)) {
              onConfigChange?.({
                ...config,
                max_steps: val ? parseInt(val, 10) : undefined,
              });
            }
          }}
          required
        />
      </div>
    </SkillCard>
  );
}
